import { apiGet, apiPost } from './utils';
import type { FHRequest, FHRecurringInfo, PagedResponse } from '../types';

export interface RecurringRunLogEntry {
  uuid: string;
  recurring_uuid: string;
  recurring_title: string | null;
  status: string; // 'created' | 'skipped' | 'no_credits' | 'inactive' | 'error'
  request_uuid: string | null;
  request_key: string | null;
  message: string | null;
  date_created: string | null;
}

export interface CreateRecurringParams {
  content: string;
  frequency: string;
  title?: string;
  weekday?: number;
  day_of_month?: number;
  [key: string]: unknown;
}

export interface EditRecurringParams {
  content?: string;
  frequency?: string;
  title?: string;
  weekday?: number;
  day_of_month?: number;
  [key: string]: unknown;
}

export interface CreateRecurringResponse {
  recurring: FHRecurringInfo;
  request: FHRequest;
}

export const recurringApi = {
  async create(params: CreateRecurringParams): Promise<CreateRecurringResponse> {
    return apiPost<CreateRecurringResponse>('/recurring/create', params);
  },

  async list(cursor?: string): Promise<PagedResponse<FHRecurringInfo>> {
    return apiGet<PagedResponse<FHRecurringInfo>>('/recurring/list', { cursor });
  },

  async get(recurringKey: string): Promise<FHRecurringInfo> {
    return apiGet<FHRecurringInfo>('/recurring/get', { recurring: recurringKey });
  },

  async edit(recurringKey: string, params: EditRecurringParams): Promise<FHRecurringInfo> {
    return apiPost<FHRecurringInfo>('/recurring/edit', { recurring: recurringKey, ...params });
  },

  async skip(recurringKey: string): Promise<FHRecurringInfo> {
    return apiPost<FHRecurringInfo>('/recurring/skip', { recurring: recurringKey });
  },

  async unskip(recurringKey: string): Promise<FHRecurringInfo> {
    return apiPost<FHRecurringInfo>('/recurring/unskip', { recurring: recurringKey });
  },

  async stop(recurringKey: string): Promise<FHRecurringInfo> {
    return apiPost<FHRecurringInfo>('/recurring/stop', { recurring: recurringKey });
  },

  async resume(recurringKey: string): Promise<FHRecurringInfo> {
    return apiPost<FHRecurringInfo>('/recurring/resume', { recurring: recurringKey });
  },

  async runLog(cursor?: string): Promise<PagedResponse<RecurringRunLogEntry>> {
    return apiGet<PagedResponse<RecurringRunLogEntry>>('/recurring/run-log', { cursor });
  },
};
